export default "__VITE_ASSET__BcN74I_g__"